import React from 'react'

const Badge = ( { label, count, color, filterAction } ) => {
    return (
        <div onClick={filterAction} className="cursor-pointer mx-2 w-32 h-6 rounded-lg grid" style={{ gridTemplateColumns: "70% 30%" }}>
         <div className="flex items-center justify-center" style={{ background: color }}>
               <span className="text-white uppercase" style={{ fontSize: "0.75rem" }}>{label}</span>
            </div>
           <div className="bg-black flex items-center justify-center">
                <span className="text-white" style={{ fontSize: "0.75rem" }}>{count}</span>
           </div>
        </div>
    )
}

export default Badge
